
import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "@/services/wordpress/config";

interface CategoryInfo {
  id: number;
  name: string;
  count?: number;
}

export const useCategoryFetch = () => {
  const [categories, setCategories] = useState<CategoryInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategoriesFromAPI = async () => {
      setLoading(true);
      try {
        const requestUrl = `${API_BASE_URL}/categories`;
        console.log(`API: Fetching categories from ${requestUrl}`);
        
        const response = await axios.get(requestUrl, { 
          params: {
            hide_empty: true,
            per_page: 100
          }
        });
        
        // Filter out categories with count of 0 (no posts)
        const categoriesData = response.data
          .filter((cat: any) => cat.count > 0)
          .map((cat: any) => ({
            id: cat.id,
            name: cat.name,
            count: cat.count || 0
          }));
        
        console.log(`API: Fetched ${categoriesData.length} non-empty categories`);
        setCategories(categoriesData);
        setError(null);
      } catch (error) {
        console.error('Failed to fetch categories:', error);
        setError('Failed to fetch categories');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchCategoriesFromAPI();
  }, []);

  return {
    categories,
    categoriesLoading: loading,
    categoriesError: error
  };
};
